import request from '@/utils/request';

// const VUE_APP_BASE_URL = 'http://20.20.10.46:10076/';
// const VUE_APP_BASE_URL_IPROX = 'https://www.iprox.cn/';
const VUE_APP_BASE_URL = '';
const VUE_APP_BASE_URL_IPROX = '';
/**
 * 登录
 * @param
 */
export function userLogin(params) {
  return request({
    url: '',
    method: 'post',
    data: params,
    // headers: {
    //   "Content-Type": "application/x-www-form-urlencoded"
    // }
  });
}

/**
 * 获取project数据
 * @param
 */
export function getProjectList(data) {
  return request({
    url: `${VUE_APP_BASE_URL_IPROX}user/selectProjectList.jsonp`,
    method: 'post',
    data,
  });
}
/**
 * 获取subproject数据
 * @param
 */
export function getSubProjectList(data) {
  return request({
    url: `${VUE_APP_BASE_URL_IPROX}user/selectSubProjectList.jsonp`,
    method: 'post',
    data,
  });
}
/**
 * 获取Week数据
 * @param
 */
export function getFileWeekData(data) {
  return request({
    url: `${VUE_APP_BASE_URL_IPROX}/user/selectFileWeek.jsonp`,
    method: 'post',
    data,
  });
}
/**
 * 获取Month数据
 * @param
 */
export function getFileMonthData(data) {
  return request({
    url: `${VUE_APP_BASE_URL_IPROX}/user/selectFileMonth.jsonp`,
    method: 'post',
    data,
  });
}
/**
 * 获取Year数据
 * @param
 */
export function getFileYearData(data) {
  return request({
    url: `${VUE_APP_BASE_URL_IPROX}/user/selectFileYear.jsonp`,
    method: 'post',
    data,
  });
}
/**
 * 获取Count数据
 * @param
 */
export function getCountData(data) {
  return request({
    url: `${VUE_APP_BASE_URL_IPROX}/user/selectCount.jsonp`,
    method: 'post',
    data,
  });
}
/**
 * 获取首页统计数据
 * @param
 */
export function getTopObjects(data) {
  return request({
    url: `${VUE_APP_BASE_URL}iprox/hfd/getTopObjects`,
    method: 'post',
    data,
  });
}
/**
 * 获取首页Basic Statistics
 * @param
 */
export function getBasicStat(data) {
  return request({
    url: `${VUE_APP_BASE_URL}iprox/hfd/getBasicStat`,
    method: 'post',
    data,
  });
}
/**
 * 获取project数据
 * @param
 */
export function getLatestProjects(data) {
  return request({
    url: `${VUE_APP_BASE_URL}iprox/hfd/getLatestProjects`,
    method: 'post',
    data,
  });
}
/**
 * 获取subproject数据
 * @param
 */
export function getLatestSubProjects(data) {
  return request({
    url: `${VUE_APP_BASE_URL}iprox/hfd/getLatestSubProjects`,
    method: 'post',
    data,
  });
}
/**
 * 获取项目详情
 * @param
 */
export function getProjectBasic(data) {
  return request({
    url: `${VUE_APP_BASE_URL}iprox/hfd/getProjectBasic`,
    method: 'post',
    data,
  });
}
/**
 * 获取项目详情—show log
 * @param
 */
export function getProjectOptLog(data) {
  return request({
    url: `${VUE_APP_BASE_URL}iprox/hfd/getProjectOptLog`,
    method: 'post',
    data,
  });
}
/* statistics页面 */
/**
 * 获取列表数据
 * @param
 */
export function getStatProjectList(data) {
  return request({
    url: `${VUE_APP_BASE_URL}iprox/hfd/getStatProjectList`,
    method: 'post',
    data,
  });
}
/**
 * 获取列表子数据
 * @param
 */
export function getStatSubProjectList(data) {
  return request({
    url: `${VUE_APP_BASE_URL}iprox/hfd/getStatSubProjectList`,
    method: 'post',
    data,
  });
}
/**
 * 子项目页面—基本信息
 * @param
 */
export function getSubProjectInfoAll(data) {
  return request({
    url: `${VUE_APP_BASE_URL}iprox/hfd/getSubProjectInfoAll`,
    method: 'post',
    data,
  });
}
/**
 * 搜索-项目列表
 * @param
 */
export function getSearchProjectList(data) {
  return request({
    url: `${VUE_APP_BASE_URL}iprox/hfd/getSearchProjectList`,
    method: 'post',
    data,
  });
}
/**
 * 搜索-子项目列表
 * @param
 */
export function getSearchSubProjectList(data) {
  return request({
    url: `${VUE_APP_BASE_URL}iprox/hfd/getSearchSubProjectList`,
    method: 'post',
    data,
  });
}
/**
 * 搜索-super项目列表
 * @param
 */
export function getSearchSuperProjectList(data) {
  return request({
    url: `${VUE_APP_BASE_URL}iprox/hfd/getSearchSuperProjectList`,
    method: 'post',
    data,
  });
}
/**
 * 搜索-sub项目-DataList
 * @param
 */
export function getSubProjectDataList(data) {
  return request({
    url: `${VUE_APP_BASE_URL}iprox/hfd/getSubProjectDataList`,
    method: 'post',
    data,
  });
}
/**
 * 搜索-项目-DataList
 * @param
 */
export function getProjectDataList(data) {
  return request({
    url: `${VUE_APP_BASE_URL}iprox/hfd/getProjectDataList`,
    method: 'post',
    data,
  });
}
/**
 * project页面-下载
 * @param
 */
export function getProjectXmlDownload(data) {
  return request({
    url: `${VUE_APP_BASE_URL}iprox/hfd/getProjectXmlDownload`,
    method: 'post',
    data,
  });
}
/**
 * supproject页面
 * @param
 */
export function getSuperProjectAll(data) {
  return request({
    url: `${VUE_APP_BASE_URL}iprox/hfd/getSuperProjectAll`,
    method: 'post',
    data,
  });
}
/**
 * browse-SuperProject
 * @param
 */
export function getBrowseSuperProjectList(data) {
  return request({
    url: `${VUE_APP_BASE_URL}iprox/hfd/getBrowseSuperProjectList`,
    method: 'post',
    data,
  });
}
/**
 * browse-Project
 * @param
 */
export function getBrowseProjectList(data) {
  return request({
    url: `${VUE_APP_BASE_URL}iprox/hfd/getBrowseProjectList`,
    method: 'post',
    data,
  });
}
/**
 * browse-Subproject
 * @param
 */
export function getBrowseSubprojectList(data) {
  return request({
    url: `${VUE_APP_BASE_URL}iprox/hfd/getBrowseSubprojectList`,
    method: 'post',
    data,
  });
}
/**
 * browse-sample
 * @param
 */
export function getCvSampleTypes(data) {
  return request({
    url: `${VUE_APP_BASE_URL}iprox/hfd/getCvSampleTypes`,
    method: 'post',
    data,
  });
}
/**
 * browse-sample-count点击事件
 * @param
 */
export function getBrowseSubprojectBySampleType(data) {
  return request({
    url: `${VUE_APP_BASE_URL}iprox/hfd/getBrowseSubprojectBySampleType`,
    method: 'post',
    data,
  });
}
/**
 * Http下载
 * @param
 */
export function downloadDataFile(data) {
  return request({
    url: `${VUE_APP_BASE_URL}iprox/hfd/downloadDataFile`,
    method: 'post',
    data,
  });
}

/**
 * 高级检索-项目列表
 * @param
 */
export function getSearchAdvProjectList(data) {
  return request({
    url: `${VUE_APP_BASE_URL}iprox/hfd/getSearchAdvProjectList`,
    method: 'post',
    data,
  });
}
/**
 * 高级检索-子项目列表
 * @param
 */
export function getSearchAdvSubProjectList(data) {
  return request({
    url: `${VUE_APP_BASE_URL}iprox/hfd/getSearchAdvSubProjectList`,
    method: 'post',
    data,
  });
}
/**
 * 高级检索-超级项目列表
 * @param
 */
export function getSearchAdvSuperProjectList(data) {
  return request({
    url: `${VUE_APP_BASE_URL}iprox/hfd/getSearchAdvSuperProjectList`,
    method: 'post',
    data,
  });
}
/**
 * 管理员统计-获取年份月份季度
 * @param
 */
export function getStatDownloadDateCv(data) {
  return request({
    url: `${VUE_APP_BASE_URL}iprox/hfd/getStatDownloadDateCv`,
    method: 'post',
    data,
  });
}
/**
 * 管理员统计-下载数据列表
 * @param
 */
export function getStatDownloadData(data) {
  return request({
    url: `${VUE_APP_BASE_URL}iprox/hfd/getStatDownloadData`,
    method: 'post',
    data,
  });
}
/**
 * 管理员统计-已发表的论文列表
 * @param
 */
export function getStatProjectsByJournal(data) {
  return request({
    url: `${VUE_APP_BASE_URL}iprox/hfd/getStatProjectsByJournal`,
    method: 'post',
    data,
  });
}
/**
 * 管理员统计-按物种、仪器、疾病、组织器官、细胞类型统计项目数和数据量（列表）
 * @param
 */
export function getStatProjectByObject(data) {
  return request({
    url: `${VUE_APP_BASE_URL}iprox/hfd/getStatProjectByObject`,
    method: 'post',
    data,
  });
}
/**
 * 管理员统计-按周、月、年统计新增的项目数（柱状图、折线图）
 * @param
 */
export function getStatProjectNewByTime(data) {
  return request({
    url: `${VUE_APP_BASE_URL}iprox/hfd/getStatProjectNewByTime`,
    method: 'post',
    data,
  });
}
/**
 * 管理员统计-按周、月、年统计累加的项目数（折线图）
 * @param
 */
export function getStatProjectAllByTime(data) {
  return request({
    url: `${VUE_APP_BASE_URL}iprox/hfd/getStatProjectAllByTime`,
    method: 'post',
    data,
  });
}
/**
 * 管理员统计-按周、月、年统计新增的项目数（折线图）
 * @param
 */
export function getStatDataNewByTime(data) {
  return request({
    url: `${VUE_APP_BASE_URL}iprox/hfd/getStatDataNewByTime`,
    method: 'post',
    data,
  });
}
/**
 * 管理员统计-按周、月、年统计累加的数据量（折线图）
 * @param
 */
export function getStatDataAllByTime(data) {
  return request({
    url: `${VUE_APP_BASE_URL}iprox/hfd/getStatDataAllByTime`,
    method: 'post',
    data,
  });
}
/**
 * 管理员统计-按周、月、年统计新增、累加的访问量（折线图）,按周、月、年统计新增、累加的点击量（折线图）
 * @param
 */
export function getStatAccessHitByTime(data) {
  return request({
    url: `${VUE_APP_BASE_URL}iprox/hfd/getStatAccessHitByTime`,
    method: 'post',
    data,
  });
}
/**
 * 管理员统计-按周、月、年统计新增的下载数据量、累加的下载数据量（折线图）
 * @param
 */
export function getStatDownloadByTime(data) {
  return request({
    url: `${VUE_APP_BASE_URL}iprox/hfd/getStatDownloadByTime`,
    method: 'post',
    data,
  });
}
/**
 * 管理员统计-按单位统计已发布/已提交的项目数和数据量
 * @param
 */
export function getStatProjectByInstitution(data) {
  return request({
    url: `${VUE_APP_BASE_URL}iprox/hfd/getStatProjectByInstitution`,
    method: 'post',
    data,
  });
}
/**
 * 管理员统计-按单位统计已发布/已提交的项目数和数据量
 * @param
 */
export function getStatProjectListByInstitution(data) {
  return request({
    url: `${VUE_APP_BASE_URL}iprox/hfd/getStatProjectListByInstitution`,
    method: 'post',
    data,
  });
}
/**
 * 管理员统计-按国家统计已发布/已提交的项目数和数据量（列表）
 * @param
 */
export function getStatProjectByCountry(data) {
  return request({
    url: `${VUE_APP_BASE_URL}iprox/hfd/getStatProjectByCountry`,
    method: 'post',
    data,
  });
}
/**
 * 管理员统计-按国家统计已发布/已提交的项目数和数据量（列表）
 * @param
 */
export function getStatProjectListByCountry(data) {
  return request({
    url: `${VUE_APP_BASE_URL}iprox/hfd/getStatProjectListByCountry`,
    method: 'post',
    data,
  });
}
/**
 * 管理员统计-17公开项目文件数据量及文件数列表
 * @param
 */
export function getStatProjectFilesize(data) {
  return request({
    url: `${VUE_APP_BASE_URL}iprox/hfd/getStatProjectFilesize`,
    method: 'post',
    data,
  });
}
/**
 * 管理员统计首页表格
 * @param
 */
export function getStatProjectGrid(data) {
  return request({
    url: `${VUE_APP_BASE_URL}iprox/hfd/getStatProjectGrid`,
    method: 'post',
    data,
  });
}

/**
 * 验证是否登录
 * @param
 */
export function selectUserById(data) {
  return request({
    url: `${VUE_APP_BASE_URL}iprox/hfd/selectUserById`,
    method: 'post',
    data,
  });
}

/**
 * 管理员统计页面获取当前时间
 * @param
 */
export function getSysVal(data) {
  return request({
    url: `${VUE_APP_BASE_URL}iprox/hfd/getSysVal`,
    method: 'post',
    data,
  });
}

/**
 * 子项目详情页面获取物种类型
 * @param
 */
export function selectStatObjectName(data) {
  return request({
    url: `${VUE_APP_BASE_URL}iprox/hfd/selectStatObjectName`,
    method: 'post',
    data,
  });
}

/**
 * Todolist列表
 * @param
 */
export function getTodoList(data) {
  return request({
    url: `${VUE_APP_BASE_URL}iprox/hfd/getTodoList`,
    method: 'post',
    data,
  });
}

/**
 * 添加todolist
 * @param
 */
export function addTodo(data) {
  return request({
    url: `${VUE_APP_BASE_URL}iprox/hfd/addTodo`,
    method: 'post',
    data,
  });
}

/**
 * 修改todolist
 * @param
 */
export function uptTodo(data) {
  return request({
    url: `${VUE_APP_BASE_URL}iprox/hfd/uptTodo`,
    method: 'post',
    data,
  });
}

/**
 * 删除todolist
 * @param
 */
export function delTodo(data) {
  return request({
    url: `${VUE_APP_BASE_URL}iprox/hfd/delTodo`,
    method: 'post',
    data,
  });
}

/**
 * changelog 列表
 * @param
 */
export function getChangeLogList(data) {
  return request({
    url: `${VUE_APP_BASE_URL}iprox/hfd/getChangeLogList`,
    method: 'post',
    data,
  });
}

/**
 * 添加changelog
 * @param
 */
export function addChangeLog(data) {
  return request({
    url: `${VUE_APP_BASE_URL}iprox/hfd/addChangeLog`,
    method: 'post',
    data,
  });
}

/**
 * 修改changelog
 * @param
 */
export function uptChangeLog(data) {
  return request({
    url: `${VUE_APP_BASE_URL}iprox/hfd/uptChangeLog`,
    method: 'post',
    data,
  });
}

/**
 * 删除changelog
 * @param
 */
export function delChangeLog(data) {
  return request({
    url: `${VUE_APP_BASE_URL}iprox/hfd/delChangeLog`,
    method: 'post',
    data,
  });
}
// 注销
/**
 * 登录
 * @param
 */
// export function userLogin(params) {
//   return request({
//     url: '',
//     method: 'post',
//     data: params,
//     // headers: {
//     //   "Content-Type": "application/x-www-form-urlencoded"
//     // }
//   });
// }

// /**
//  * 获取project数据
//  * @param
//  */
// export function getProjectList(data) {
//   return request({
//     url: `${VUE_APP_BASE_URL_IPROX}user/selectProjectList.jsonp`,
//     method: 'post',
//     data,
//   });
// }
// /**
//  * 获取subproject数据
//  * @param
//  */
// export function getSubProjectList(data) {
//   return request({
//     url: `${VUE_APP_BASE_URL_IPROX}user/selectSubProjectList.jsonp`,
//     method: 'post',
//     data,
//   });
// }
// /**
//  * 获取Week数据
//  * @param
//  */
// export function getFileWeekData(data) {
//   return request({
//     url: `${VUE_APP_BASE_URL_IPROX}/user/selectFileWeek.jsonp`,
//     method: 'post',
//     data,
//   });
// }
// /**
//  * 获取Month数据
//  * @param
//  */
// export function getFileMonthData(data) {
//   return request({
//     url: `${VUE_APP_BASE_URL_IPROX}/user/selectFileMonth.jsonp`,
//     method: 'post',
//     data,
//   });
// }
// /**
//  * 获取Year数据
//  * @param
//  */
// export function getFileYearData(data) {
//   return request({
//     url: `${VUE_APP_BASE_URL_IPROX}/user/selectFileYear.jsonp`,
//     method: 'post',
//     data,
//   });
// }
// /**
//  * 获取Count数据
//  * @param
//  */
// export function getCountData(data) {
//   return request({
//     url: `${VUE_APP_BASE_URL_IPROX}/user/selectCount.jsonp`,
//     method: 'post',
//     data,
//   });
// }
// /**
//  * 获取首页统计数据
//  * @param
//  */
// export function getTopObjects(data) {
//   return request({
//     url: 'iprox/hfd/getTopObjects',
//     method: 'post',
//     data,
//   });
// }
// /**
//  * 获取首页Basic Statistics
//  * @param
//  */
// export function getBasicStat(data) {
//   return request({
//     url: 'iprox/hfd/getBasicStat',
//     method: 'post',
//     data,
//   });
// }
// /**
//  * 获取project数据
//  * @param
//  */
// export function getLatestProjects(data) {
//   return request({
//     url: 'iprox/hfd/getLatestProjects',
//     method: 'post',
//     data,
//   });
// }
// /**
//  * 获取subproject数据
//  * @param
//  */
// export function getLatestSubProjects(data) {
//   return request({
//     url: 'iprox/hfd/getLatestSubProjects',
//     method: 'post',
//     data,
//   });
// }
// /**
//  * 获取项目详情
//  * @param
//  */
// export function getProjectBasic(data) {
//   return request({
//     url: 'iprox/hfd/getProjectBasic',
//     method: 'post',
//     data,
//   });
// }
// /**
//  * 获取项目详情—show log
//  * @param
//  */
// export function getProjectOptLog(data) {
//   return request({
//     url: 'iprox/hfd/getProjectOptLog',
//     method: 'post',
//     data,
//   });
// }
// /* statistics页面 */
// /**
//  * 获取列表数据
//  * @param
//  */
// export function getStatProjectList(data) {
//   return request({
//     url: 'iprox/hfd/getStatProjectList',
//     method: 'post',
//     data,
//   });
// }
// /**
//  * 获取列表子数据
//  * @param
//  */
// export function getStatSubProjectList(data) {
//   return request({
//     url: 'iprox/hfd/getStatSubProjectList',
//     method: 'post',
//     data,
//   });
// }
// /**
//  * 子项目页面—基本信息
//  * @param
//  */
// export function getSubProjectInfoAll(data) {
//   return request({
//     url: 'iprox/hfd/getSubProjectInfoAll',
//     method: 'post',
//     data,
//   });
// }
// /**
//  * 搜索-项目列表
//  * @param
//  */
// export function getSearchProjectList(data) {
//   return request({
//     url: 'iprox/hfd/getSearchProjectList',
//     method: 'post',
//     data,
//   });
// }
// /**
//  * 搜索-子项目列表
//  * @param
//  */
// export function getSearchSubProjectList(data) {
//   return request({
//     url: 'iprox/hfd/getSearchSubProjectList',
//     method: 'post',
//     data,
//   });
// }
// /**
//  * 搜索-super项目列表
//  * @param
//  */
// export function getSearchSuperProjectList(data) {
//   return request({
//     url: 'iprox/hfd/getSearchSuperProjectList',
//     method: 'post',
//     data,
//   });
// }
// /**
//  * 搜索-sub项目-DataList
//  * @param
//  */
// export function getSubProjectDataList(data) {
//   return request({
//     url: 'iprox/hfd/getSubProjectDataList',
//     method: 'post',
//     data,
//   });
// }
// /**
//  * 搜索-项目-DataList
//  * @param
//  */
// export function getProjectDataList(data) {
//   return request({
//     url: 'iprox/hfd/getProjectDataList',
//     method: 'post',
//     data,
//   });
// }
// /**
//  * project页面-下载
//  * @param
//  */
// export function getProjectXmlDownload(data) {
//   return request({
//     url: 'iprox/hfd/getProjectXmlDownload',
//     method: 'post',
//     data,
//   });
// }
// /**
//  * supproject页面
//  * @param
//  */
// export function getSuperProjectAll(data) {
//   return request({
//     url: 'iprox/hfd/getSuperProjectAll',
//     method: 'post',
//     data,
//   });
// }
// /**
//  * browse-SuperProject
//  * @param
//  */
// export function getBrowseSuperProjectList(data) {
//   return request({
//     url: 'iprox/hfd/getBrowseSuperProjectList',
//     method: 'post',
//     data,
//   });
// }
// /**
//  * browse-Project
//  * @param
//  */
// export function getBrowseProjectList(data) {
//   return request({
//     url: 'iprox/hfd/getBrowseProjectList',
//     method: 'post',
//     data,
//   });
// }
// /**
//  * browse-Subproject
//  * @param
//  */
// export function getBrowseSubprojectList(data) {
//   return request({
//     url: 'iprox/hfd/getBrowseSubprojectList',
//     method: 'post',
//     data,
//   });
// }
// /**
//  * browse-sample
//  * @param
//  */
// export function getCvSampleTypes(data) {
//   return request({
//     url: 'iprox/hfd/getCvSampleTypes',
//     method: 'post',
//     data,
//   });
// }
// /**
//  * browse-sample-count点击事件
//  * @param
//  */
// export function getBrowseSubprojectBySampleType(data) {
//   return request({
//     url: 'iprox/hfd/getBrowseSubprojectBySampleType',
//     method: 'post',
//     data,
//   });
// }
// /**
//  * Http下载
//  * @param
//  */
// export function downloadDataFile(data) {
//   return request({
//     url: 'iprox/hfd/downloadDataFile',
//     method: 'post',
//     data,
//   });
// }

// /**
//  * 高级检索-项目列表
//  * @param
//  */
// export function getSearchAdvProjectList(data) {
//   return request({
//     url: 'iprox/hfd/getSearchAdvProjectList',
//     method: 'post',
//     data,
//   });
// }
// /**
//  * 高级检索-子项目列表
//  * @param
//  */
// export function getSearchAdvSubProjectList(data) {
//   return request({
//     url: 'iprox/hfd/getSearchAdvSubProjectList',
//     method: 'post',
//     data,
//   });
// }
// /**
//  * 高级检索-超级项目列表
//  * @param
//  */
// export function getSearchAdvSuperProjectList(data) {
//   return request({
//     url: 'iprox/hfd/getSearchAdvSuperProjectList',
//     method: 'post',
//     data,
//   });
// }
// /**
//  * 管理员统计-获取年份月份季度
//  * @param
//  */
// export function getStatDownloadDateCv(data) {
//   return request({
//     url: 'iprox/hfd/getStatDownloadDateCv',
//     method: 'post',
//     data,
//   });
// }
// /**
//  * 管理员统计-下载数据列表
//  * @param
//  */
// export function getStatDownloadData(data) {
//   return request({
//     url: 'iprox/hfd/getStatDownloadData',
//     method: 'post',
//     data,
//   });
// }
// /**
//  * 管理员统计-已发表的论文列表
//  * @param
//  */
// export function getStatProjectsByJournal(data) {
//   return request({
//     url: 'iprox/hfd/getStatProjectsByJournal',
//     method: 'post',
//     data,
//   });
// }
// /**
//  * 管理员统计-按物种、仪器、疾病、组织器官、细胞类型统计项目数和数据量（列表）
//  * @param
//  */
// export function getStatProjectByObject(data) {
//   return request({
//     url: 'iprox/hfd/getStatProjectByObject',
//     method: 'post',
//     data,
//   });
// }
// /**
//  * 管理员统计-按周、月、年统计新增的项目数（柱状图、折线图）
//  * @param
//  */
// export function getStatProjectNewByTime(data) {
//   return request({
//     url: 'iprox/hfd/getStatProjectNewByTime',
//     method: 'post',
//     data,
//   });
// }
// /**
//  * 管理员统计-按周、月、年统计累加的项目数（折线图）
//  * @param
//  */
// export function getStatProjectAllByTime(data) {
//   return request({
//     url: 'iprox/hfd/getStatProjectAllByTime',
//     method: 'post',
//     data,
//   });
// }
// /**
//  * 管理员统计-按周、月、年统计新增的项目数（折线图）
//  * @param
//  */
// export function getStatDataNewByTime(data) {
//   return request({
//     url: 'iprox/hfd/getStatDataNewByTime',
//     method: 'post',
//     data,
//   });
// }
// /**
//  * 管理员统计-按周、月、年统计累加的数据量（折线图）
//  * @param
//  */
// export function getStatDataAllByTime(data) {
//   return request({
//     url: 'iprox/hfd/getStatDataAllByTime',
//     method: 'post',
//     data,
//   });
// }
// /**
//  * 管理员统计-按周、月、年统计新增、累加的访问量（折线图）,按周、月、年统计新增、累加的点击量（折线图）
//  * @param
//  */
// export function getStatAccessHitByTime(data) {
//   return request({
//     url: 'iprox/hfd/getStatAccessHitByTime',
//     method: 'post',
//     data,
//   });
// }
// /**
//  * 管理员统计-按周、月、年统计新增的下载数据量、累加的下载数据量（折线图）
//  * @param
//  */
// export function getStatDownloadByTime(data) {
//   return request({
//     url: 'iprox/hfd/getStatDownloadByTime',
//     method: 'post',
//     data,
//   });
// }
// /**
//  * 管理员统计-按单位统计已发布/已提交的项目数和数据量
//  * @param
//  */
// export function getStatProjectByInstitution(data) {
//   return request({
//     url: 'iprox/hfd/getStatProjectByInstitution',
//     method: 'post',
//     data,
//   });
// }
// /**
//  * 管理员统计-按单位统计已发布/已提交的项目数和数据量
//  * @param
//  */
// export function getStatProjectListByInstitution(data) {
//   return request({
//     url: 'iprox/hfd/getStatProjectListByInstitution',
//     method: 'post',
//     data,
//   });
// }
// /**
//  * 管理员统计-按国家统计已发布/已提交的项目数和数据量（列表）
//  * @param
//  */
// export function getStatProjectByCountry(data) {
//   return request({
//     url: 'iprox/hfd/getStatProjectByCountry',
//     method: 'post',
//     data,
//   });
// }
// /**
//  * 管理员统计-按国家统计已发布/已提交的项目数和数据量（列表）
//  * @param
//  */
// export function getStatProjectListByCountry(data) {
//   return request({
//     url: 'iprox/hfd/getStatProjectListByCountry',
//     method: 'post',
//     data,
//   });
// }
// /**
//  * 管理员统计首页表格
//  * @param
//  */
// export function getStatProjectGrid(data) {
//   return request({
//     url: 'iprox/hfd/getStatProjectGrid',
//     method: 'post',
//     data,
//   });
// }
